var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-slider",
    _vm._g(
      _vm._b(
        {
          ref: "vueSlider",
          staticClass: "slider",
          attrs: { "use-keyboard": true },
        },
        "vue-slider",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }